import { create } from "zustand";

export const usePlanLimitStore = create((set) => ({
  isOpen: false,
  data: null, // { title, message, featureName, limitType, limit, current, remaining }
  openLimitModal: (data) =>
    set({
      isOpen: true,
      data: typeof data === "string" ? { message: data } : data || {},
    }),
  closeLimitModal: () => set({ isOpen: false, data: null }),
}));
